export default __webpack_public_path__ + "static/media/Step2-1.26134b09.png";